<template>
    <div class="relative inline-block text-left">
        <template v-if="squareButton">
            <button
                @click="openForm()"
                type="button"
                class="text-indigo-700 bg-indigo-100 hover:bg-indigo-200 inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <svg viewBox="0 0 20 20" fill="currentColor" class="pencil w-4 h-4">
                    <path
                        d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                    ></path>
                </svg>
            </button>
        </template>
        <AppButton element="button" @click="openForm()" type="button" v-else>
            {{ $t('messages.add') }}
        </AppButton>

        <div>
            <SlideOver :title="$t('messages.edit')" :show="open" @close="closeForm()">
                <div class="text-gray-600">
                    {{ student.full_name }}
                </div>

                <form :action="url" method="post" @submit.prevent="submit">
                    <div class="">
                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.date')" for="paid_at">
                                    <span v-if="!form.paid_at">
                                        <button @click="setDateToToday()" class="text-xs text-indigo-400" type="button">
                                            {{ $t('messages.today?') }}
                                        </button>
                                    </span>
                                </FormLabel>
                                <FormInput
                                    required
                                    id="paid_at"
                                    v-model="form.paid_at"
                                    name="paid_at"
                                    type="date"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.paid_at" class="mt-2" />
                            </div>
                        </div>

                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.type')" for="select_id" />
                                <FormSelect
                                    required
                                    id="select_id"
                                    v-model="form.select_id"
                                    :options="selects"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.select_id" class="mt-2" />
                            </div>
                        </div>

                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.quantity')" for="amount" />
                                <FormInput
                                    required
                                    id="amount"
                                    v-model="form.amount"
                                    name="amount"
                                    type="number"
                                    class="mt-1 w-full"
                                    step="0.01"
                                />
                                <FormError :value="form.errors.amount" class="mt-2" />
                            </div>
                        </div>

                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$tc('messages.scholarships', 1)" for="scholarship_id" />
                                <FormSelect
                                    id="scholarship_id"
                                    v-model="form.scholarship_id"
                                    :options="scholarships"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.scholarship_id" class="mt-2" />
                            </div>
                        </div>

                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.comment')" for="comment">
                                    <template v-slot:corner>
                                        <CharCounter
                                            :value="form.comment"
                                            :max="180"
                                            show-max
                                            class="text-sm font-medium leading-5 text-gray-500"
                                        />
                                    </template>
                                </FormLabel>
                                <FormTextarea
                                    id="comment"
                                    v-model="form.comment"
                                    name="comment"
                                    maxlength="180"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.comment" class="mt-2" />
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-end mt-5">
                        <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                            {{ $t('messages.save') }}
                            <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                        </AppButton>
                    </div>
                </form>
            </SlideOver>
        </div>
    </div>
</template>

<script>
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import AppButton from '@/components/AppButton.vue';
import SlideOver from '@/components/SlideOver.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import CharCounter from '@/components/Forms/CharCounter.vue';

export default {
    emits: ['close'],
    name: 'StudentPaymentEditFormPanel',

    components: {
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
        FormTextarea,
        CharCounter,
        AppButton,
        SlideOver,
    },

    props: {
        squareButton: {
            required: false,
            type: Boolean,
            default: false,
        },
        url: {
            required: true,
            type: String,
        },
        student: {
            required: true,
            type: Object,
        },
        selects: {
            required: true,
            type: Array,
        },
        scholarships: {
            required: true,
            type: Array,
        },
        payment: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            open: false,
            form: this.$inertia.form({
                amount: this.payment.amount,
                paid_at: this.payment.paid_at,
                scholarship_id: this.payment.scholarship_id,
                select_id: this.payment.select_id,
                comment: this.payment.comment,
            }),
        };
    },

    methods: {
        dismiss() {
            this.$emit('close');
        },
        openForm() {
            this.open = true;
        },
        closeForm() {
            this.open = false;
        },
        setDateToToday() {
            this.form.paid_at = new Date().toISOString().slice(0, 10);
        },
        submit() {
            const url = this.url;
            this.form.patch(url, {
                preserveScroll: true,
                onSuccess: () => {
                    this.open = false;
                },
            });
        },
    },
};
</script>
